import useSWR from "swr"

import type { API_ROUTES_CUSTOMER_ONGOING_ORDER_RETURN } from "@/app/api/customer/ongoing-order/routeUtils"
import { API_ROUTES_CUSTOMER_ONGOING_ORDER } from "@/app/api/customer/ongoing-order/routeUtils"
import { useCustomerProfile } from "../useGlobalStore"

export function usePendingOrder() {
  const customerProfile = useCustomerProfile({ required: false })
  const customerId = customerProfile?.customerProfile?.id

  const key = customerId ? API_ROUTES_CUSTOMER_ONGOING_ORDER.get(customerId, "PENDING") : null
  const fetcher = async () => {
    if (!key) return null
    const res = await fetch(key)
    const data = (await res.json()) as API_ROUTES_CUSTOMER_ONGOING_ORDER_RETURN
    return data ?? null
  }
  const { data: pendingOrder, mutate: invalidatePendingOrder } = useSWR(key, fetcher, {
    refreshInterval: customerId ? 5000 : 0,
  })
  return { pendingOrder, invalidatePendingOrder, key }
}
